import { Tooltip, TooltipContent, TooltipTrigger } from '@/shared/components/ui/tooltip';
import type { TimelineTaskBarModel } from '../../types';

interface TimelineTaskBarProps {
  task: TimelineTaskBarModel;
  leftPx: number;
  widthPx: number;
  onClick: (taskId: string) => void;
}

/** A task bar within a person's swimlane, colored via `resolveTimelineBarColor` (the assignee's color). Opens the task on click. */
export function TimelineTaskBar({ task, leftPx, widthPx, onClick }: TimelineTaskBarProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          type="button"
          data-testid="tasks-timeline-task-bar"
          className="absolute top-1/2 flex h-8 -translate-y-1/2 cursor-pointer items-center overflow-hidden rounded-md px-2.5 text-left"
          style={{ left: leftPx, width: widthPx, backgroundColor: task.color }}
          onClick={() => onClick(task.id)}
        >
          <p className="truncate text-xs font-medium text-white">{task.title}</p>
        </button>
      </TooltipTrigger>
      <TooltipContent>{task.title}</TooltipContent>
    </Tooltip>
  );
}
